import { TemplatesApi } from 'src/app/hickory-api';

export class MockTemplatesApi extends TemplatesApi { }
